"use client";

import { Button } from "@/components";
import { useRouter } from "next/navigation";
import React from "react";

const NotFoundPage: React.FC = () => {
  const router = useRouter();

  const handleGoHome = () => {
    router.push("/listings");
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="text-center">
          <h1 className="text-6xl font-bold font-raleway mb-4">404</h1>
          <h2 className="text-2xl font-bold font-raleway mb-4">
            Page Not Found
          </h2>
          <p className="font-raleway text-grey mb-8 max-w-md">
            Sorry, the page you&apos;re looking for doesn&apos;t exist or has
            been moved.
          </p>
          <Button onClick={handleGoHome}>Browse Listings</Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
